import React from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Col,
  Modal,
  Tab,
  Row,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { tambahMarketing } from "stores";
import { getAllMarketing } from "stores";
import { getAllClient } from "stores";
import { getAllCabang } from "stores";
import { penempatanMarketing } from "stores";
import { editStatusMarketing } from "stores";
import moment from "moment";
import { resetPassword } from "stores";
import { Dna } from "react-loader-spinner";

function ListMarketing() {
  const dispatch = useDispatch();
  const marketing = useSelector((state) => state.marketingReducer);
  const storeClient = useSelector((state) => state.clientReducer);
  const storeCabang = useSelector((state) => state.cabangReducer);
  const auth = useSelector((state) => state.authReducer);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const [salesMarketing, setSalesMarketing] = React.useState(false);
  const [modalPenempatan, setModalPenempatan] = React.useState(false);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [modalDetail, setModalDetail] = React.useState(false);
  const [modalUbahPenempatan, setModalUbahPenempatan] = React.useState(false);
  const [pilihClient, setPilihClient] = React.useState(null);
  const [pilihRole, setPilihRole] = React.useState(null);
  const [role, setRole] = React.useState("");
  const [nik, setNik] = React.useState("");
  const [nama, setNama] = React.useState("");
  const [nopeg, setNopeg] = React.useState("");
  const [listClient, setListClient] = React.useState([]);
  const [listMarketing, setListMarketing] = React.useState([]);
  const [idClient, setIdClient] = React.useState("");
  const [pilihCabang, setPilihCabang] = React.useState(null);
  const [listCabang, setListCabang] = React.useState([]);
  const [idCabang, setIdCabang] = React.useState(null);
  const [idMarketing, setIdMarketing] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [searchText, setSearchText] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(true);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleNikChange = (e) => {
    const inputNik = e.target.value;
    const formattedNik = inputNik.slice(0, 16);
    setNik(formattedNik);
  };

  const remainingDigits = 16 - nik.length;

  const submitMarketing = () => {
    if (nik.length < 16) {
      Swal.fire({
        title: "NIK harus 16 digit !!",
        icon: "warning",
      });
      return;
    }
    tambahMarketing({
      nik: nik,
      nama: nama,
      nopeg: nopeg,
      role: role,
      idClient: idClient,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          getAllMarketing(dispatch, { idClient: "" });
          // setIdClient("");
          // setPilihClient("");
          // setPilihRole("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
      });
  };

  const checkStatus = () => {
    if (status.value === undefined || status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status wajib diisi !",
      });
    } else {
      submitEditStatus();
    }
  };

  const submitEditStatus = () => {
    // console.log(status.value);
    editStatusMarketing({
      idMarketing: idMarketing,
      status: status.value,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllMarketing(dispatch, { idClient: "" });
          setModalEdit(false);
          setStatus("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const submitPenempatan = () => {
    if (pilihCabang === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Cabang tidak boleh kosong",
      });
    } else {
      penempatanMarketing({
        idMarketing: idMarketing,
        idCabang: idCabang,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          setIdCabang("");
          setPilihCabang("");
          getAllMarketing(dispatch, { idClient: "" });
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const submitUbahPenempatan = () => {
    if (pilihCabang === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Cabang tidak boleh kosong",
      });
    } else {
      penempatanMarketing({
        idMarketing: idMarketing,
        idCabang: idCabang,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          handleModalClose();
          setIdCabang(null);
          setPilihCabang(null);
          getAllMarketing(dispatch, { idClient: "" });
        }
      });
    }
  };

  const handleModalClose = () => {
    setPilihCabang(null);
    setIdCabang(null);
    setPilihRole(null);
    setRole("");
    setPilihClient(null);
    setSalesMarketing(false);
    setModalPenempatan(false);
    setModalUbahPenempatan(false);
    setNik("");
    setNopeg("");
    setNama("");
  };

  React.useEffect(() => {
    let tmp =
      marketing.listMarketing &&
      marketing.listMarketing.map((val) => {
        const ubahPenempatan = val.penempatan != "";
        return {
          ...val,
          action: (
            <div
              className="d-flex align-items-center flex-wrap"
              style={{ gap: "8px" }}
            >
              {auth.role === "super admin" || auth.role === "admin" ? (
                <>
                  {/* TOMBOL PENEMPATAN / UBAH PENEMPATAN */}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-map-mkt-${val._id}`}>
                        {ubahPenempatan
                          ? "Ubah Penempatan"
                          : "Penempatan Marketing"}
                      </Tooltip>
                    }
                  >
                    <Button
                      disabled={!ubahPenempatan && val.status === "tidak aktif"}
                      className="d-flex align-items-center justify-content-center shadow-sm"
                      style={{
                        marginTop: 5,
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: "none",
                        backgroundColor: ubahPenempatan
                          ? "#ff9800" // Orange/Warning untuk Ubah
                          : val.status === "tidak aktif"
                            ? "#cbd5e1"
                            : "#447DF7", // Biru untuk Penempatan Baru
                        color: "white",
                        cursor:
                          !ubahPenempatan && val.status === "tidak aktif"
                            ? "not-allowed"
                            : "pointer",
                        transition: "all 0.2s ease",
                      }}
                      onClick={() => {
                        setIdMarketing(val._id);
                        getAllCabang(dispatch, { idClient: val.idClient });
                        if (ubahPenempatan) {
                          setModalUbahPenempatan(!modalUbahPenempatan);
                        } else {
                          setModalPenempatan(!modalPenempatan);
                        }
                      }}
                      onMouseOver={(e) => {
                        if (val.status === "aktif" || ubahPenempatan)
                          e.currentTarget.style.transform = "translateY(-2px)";
                      }}
                      onMouseOut={(e) => {
                        if (val.status === "aktif" || ubahPenempatan)
                          e.currentTarget.style.transform = "translateY(0)";
                      }}
                    >
                      <i
                        className={`fas ${ubahPenempatan ? "fa-map-marked" : "fa-map-marked-alt"}`}
                        style={{ fontSize: "16px" }}
                      ></i>
                    </Button>
                  </OverlayTrigger>

                  {/* TOMBOL EDIT STATUS */}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-edit-mkt-${val._id}`}>
                        Edit Status
                      </Tooltip>
                    }
                  >
                    <Button
                      className="d-flex align-items-center justify-content-center shadow-sm"
                      style={{
                        marginTop: 5,
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: "none",
                        backgroundColor: "#10b981", // Emerald Green
                        color: "white",
                        transition: "all 0.2s ease",
                      }}
                      onClick={() => {
                        setIdMarketing(val._id);
                        setModalEdit(!modalEdit);
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.transform = "translateY(-2px)")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.transform = "translateY(0)")
                      }
                    >
                      <i
                        className="fas fa-edit"
                        style={{ fontSize: "16px" }}
                      ></i>
                    </Button>
                  </OverlayTrigger>

                  {/* TOMBOL RESET PASSWORD */}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-reset-mkt-${val._id}`}>
                        Reset Password
                      </Tooltip>
                    }
                  >
                    <Button
                      className="d-flex align-items-center justify-content-center shadow-sm"
                      style={{
                        marginTop: 5,
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: "none",
                        backgroundColor: "#f90203", // Merah BPR Jatim
                        color: "white",
                        transition: "all 0.2s ease",
                      }}
                      onClick={async () => {
                        const result = await Swal.fire({
                          title: "Reset Password",
                          text: `Reset password untuk marketing ${val.nama}?`,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#2e3192", // Biru BPR Jatim
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Ya, Reset!",
                          cancelButtonText: "Batal",
                        });

                        if (result.isConfirmed) {
                          try {
                            const response = await resetPassword({
                              idUser: val._id,
                              role: val.role,
                            });
                            Swal.fire({
                              title: "Sukses",
                              text: response.data.message,
                              icon: "success",
                            });
                          } catch (error) {
                            Swal.fire({
                              title: "Error",
                              text: "Gagal mereset password",
                              icon: "error",
                            });
                          }
                        }
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.transform = "translateY(-2px)")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.transform = "translateY(0)")
                      }
                    >
                      <i
                        className="fas fa-redo-alt"
                        style={{ fontSize: "16px" }}
                      ></i>
                    </Button>
                  </OverlayTrigger>
                </>
              ) : (
                <span className="text-muted fw-bold ml-2">—</span>
              )}
            </div>
          ),
        };
      });
    setListMarketing(tmp);
  }, [
    marketing.listMarketing,
    auth,
    modalEdit,
    modalPenempatan,
    modalUbahPenempatan,
  ]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeCabang.listCabang &&
      storeCabang.listCabang.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaCabang,
        });
      });

    setListCabang(tmp);
  }, [storeCabang.listCabang]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });

    setListClient(tmp);
  }, [storeClient.listClient]);

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#ffffff",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f1f5f9",
        minHeight: "55px",
        borderTop: "1px solid #e2e8f0",
        borderBottom: "2px solid #e2e8f0",
      },
    },
    headCells: {
      style: {
        fontSize: "13px",
        fontWeight: "800",
        textTransform: "uppercase",
        color: "#475569",
        justifyContent: "flex-start",
        paddingLeft: "20px",
      },
    },
    rows: {
      style: {
        minHeight: "75px",
        "&:not(:last-of-type)": {
          borderBottom: "1px solid #f1f5f9",
        },
        "&:hover": {
          backgroundColor: "#f8fafc",
          transition: "0.2s",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
        justifyContent: "flex-start",
        paddingLeft: "20px",
      },
    },
  };

  const colSalesMarketing = [
    {
      name: "NO",
      width: "70px",
      center: false,
      cell: (row, index) => (
        <span className="fw-800 text-muted ml-1">
          {(currentPage - 1) * itemsPerPage + index + 1}
        </span>
      ),
    },
    {
      name: "DATA SALES MARKETING",
      minWidth: "300px",
      center: false,
      cell: (row) => (
        <div className="d-flex align-items-center ml-1 py-2">
          <div
            className="mr-3 d-flex align-items-center justify-content-center rounded-lg shadow-sm"
            style={{
              width: "42px",
              height: "42px",
              background: "linear-gradient(135deg, #2e3192 0%, #1e293b 100%)",
              color: "white",
              fontWeight: "900",
            }}
          >
            {row.nama.charAt(0).toUpperCase()}
          </div>
          <div className="py-2">
            {/* Nama User */}
            <div
              className="text-dark mb-1"
              style={{ fontSize: "14px", fontWeight: "700" }}
            >
              {row.nama}
            </div>
            {/* Nopeg - Diperbesar & Tebal */}
            <div
              className="text-muted mb-1"
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#1D3557",
                letterSpacing: "0.5px",
              }}
            >
              {row.nopeg}
            </div>
          </div>
        </div>
      ),
    },
    {
      name: "Kode User",
      minWidth: "120px",
      cell: (row) => (
        <span
          className="badge bg-light text-muted border px-2 py-1"
          style={{ fontSize: "12px", fontWeight: "600" }}
        >
          {row.kodeUser}
        </span>
      ),
    },
    {
      name: "Jabatan",
      minWidth: "220px",
      cell: (row) => {
        const isDirect = row.role !== "marketing";

        return (
          <div style={{ padding: "5px 0" }}>
            {/* Teks Jabatan Utama */}
            <div
              style={{
                fontSize: "13px",
                fontWeight: "800",
                color: isDirect ? "#1D3557" : "#5A6A85", // Navy untuk Direct, Grey-Blue untuk Reguler
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                lineHeight: "1.2",
              }}
            >
              {row.role === "marketing"
                ? "Sales Marketing"
                : "Direct Sales Marketing"}
            </div>

            {/* Garis aksen kecil di bawah untuk pembeda visual yang tipis */}
            <div
              style={{
                width: "25px",
                height: "3px",
                backgroundColor: isDirect ? "#F87171" : "#4E73DF", // Merah tipis untuk Direct, Biru untuk Reguler
                marginTop: "4px",
                borderRadius: "10px",
              }}
            ></div>
          </div>
        );
      },
    },
    {
      name: "Penempatan (BPD/Cabang)",
      minWidth: "250px",
      cell: (row) => {
        // Mengecek apakah ada data penempatan
        const hasPlacement =
          row.penempatan &&
          row.penempatan.length > 0 &&
          row.penempatan[0].namaCabang;

        return (
          <div className="py-2">
            {hasPlacement ? (
              <>
                {/* Tampilan Jika Sudah Ada Penempatan */}
                <div className="fw-bold text-dark" style={{ fontSize: "13px" }}>
                  <i className="fas fa-university mr-2 text-primary"></i>
                  {row.penempatan[0].namaClient}
                </div>
                <div className="text-muted" style={{ fontSize: "12px" }}>
                  <i className="fas fa-map-marker-alt mr-2 text-danger"></i>
                  <b>{row.penempatan[0].namaCabang}</b>
                </div>
              </>
            ) : (
              /* Tampilan Jika Belum Ada Penempatan (Sesuai Permintaan Anda) */
              <div
                className="d-flex align-items-center text-muted"
                style={{ fontStyle: "italic", fontSize: "13px" }}
              >
                <i className="fas fa-minus-circle mr-2 opacity-50"></i>
                Belum ada penempatan
              </div>
            )}
          </div>
        );
      },
    },
    {
      name: "Akses Marketing",
      minWidth: "180px",
      center: true,
      cell: (row) =>
        !row.kategoriMarketing ? (
          <span
            className="badge bg-soft-danger text-danger border border-danger px-2 py-1"
            style={{ fontSize: "11px" }}
          >
            BELUM ADA AKSES
          </span>
        ) : (
          <span
            className="badge bg-soft-primary text-primary border border-primary px-3 py-1 text-capitalize"
            style={{ fontSize: "12px" }}
          >
            <i className="fas fa-unlock-alt mr-1"></i> {row.kategoriMarketing}
          </span>
        ),
    },
    {
      name: "Aktivitas",
      minWidth: "180px",
      cell: (row) => (
        <div style={{ fontSize: "12px" }}>
          <div className="text-muted">Login Terakhir:</div>
          <div className="fw-bold text-dark">
            {row.loginDate
              ? moment(row.loginDate).format("DD MMM YYYY, HH:mm")
              : "-"}
          </div>
        </div>
      ),
    },
    {
      name: "Status",
      minWidth: "140px",
      center: true,
      cell: (row) => {
        const isActive = row.status === "aktif";
        return (
          <span
            style={{
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "bold",
              backgroundColor: isActive ? "#D1FAE5" : "#FEE2E2",
              color: isActive ? "#065F46" : "#991B1B",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#10B981" : "#EF4444",
                marginRight: "8px",
              }}
            ></span>
            {isActive ? "Aktif" : "Tidak Aktif"}
          </span>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "250px",
      center: true,
      omit: !(auth.role === "super admin" || auth.role === "admin"),
      cell: (row) => row.action,
    },
  ];

  React.useEffect(() => {
    getAllMarketing(dispatch, { idClient: "" })
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
    getAllClient(dispatch);
  }, []);

  return (
    <>
      {/* MODAL PENEMPATAN / UBAH PENEMPATAN */}
      <Modal
        size="md"
        show={modalPenempatan || modalUbahPenempatan}
        onHide={() => {
          handleModalClose();
          setModalPenempatan(false);
          setModalUbahPenempatan(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className={`fas ${modalUbahPenempatan ? "fa-map-pin" : "fa-map-marked-alt"} fa-2x text-white`}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">
              {modalUbahPenempatan ? "Ubah Penempatan" : "Form Penempatan"}
            </h3>
            <p className="text-muted">
              Tentukan cabang wilayah tugas untuk personil ini
            </p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              <Form.Group className="mb-4">
                <label className="fw-bold text-dark mb-2">Pilih Cabang</label>
                <Select
                  classNamePrefix="react-select"
                  value={pilihCabang}
                  onChange={(value) => {
                    setPilihCabang(value);
                    setIdCabang(value.value);
                  }}
                  options={listCabang}
                  placeholder="Cari Cabang..."
                />
              </Form.Group>
              <Button
                className="btn-block p-3 text-white"
                style={{
                  border: "none",
                  backgroundColor: "#1D3557",
                  borderRadius: "15px",
                  fontWeight: "800",
                  boxShadow: "0 10px 20px rgba(29, 53, 87, 0.3)",
                }}
                onClick={
                  modalUbahPenempatan ? submitUbahPenempatan : submitPenempatan
                }
              >
                {modalUbahPenempatan
                  ? "UPDATE PENEMPATAN"
                  : "SIMPAN PENEMPATAN"}
              </Button>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      {/* MODAL EDIT STATUS */}
      <Modal
        size="sm"
        show={modalEdit}
        onHide={() => {
          setStatus("");
          setModalEdit(!modalEdit);
        }}
        centered
        contentClassName="border-0 shadow-lg"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-4 pb-4 text-center">
          <div className="mb-3" style={{ color: "#2e3192" }}>
            <i className="fas fa-user-check fa-3x"></i>
          </div>
          <h4 className="font-weight-bold mb-1">EDIT STATUS</h4>
          <p className="text-muted small mb-4">Ubah keaktifan akun marketing</p>
          <Select
            classNamePrefix="react-select"
            value={status}
            onChange={(v) => setStatus(v)}
            options={[
              { value: "true", label: "✅ AKTIF" },
              { value: "false", label: "❌ TIDAK AKTIF" },
            ]}
            styles={{ control: (b) => ({ ...b, borderRadius: "10px" }) }}
          />
          <Button
            className="btn-block py-3 mt-4 border-0 fw-900 shadow-sm"
            style={{
              background: "#2e3192",
              borderRadius: "12px",
              color: "white",
            }}
            onClick={checkStatus}
          >
            UPDATE STATUS
          </Button>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={salesMarketing}
        onHide={() => {
          handleModalClose();
          setSalesMarketing(false);
        }}
        centered
        contentClassName="border-0 shadow-2xl"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-5 pb-5">
          <div className="d-flex align-items-center mb-4">
            <div
              className="p-3 mr-3 shadow-sm"
              style={{
                background: "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                borderRadius: "15px",
                color: "white",
              }}
            >
              <i className="fas fa-user-plus fa-lg"></i>
            </div>
            <div>
              <h3 className="m-0 font-weight-bold">TAMBAH MARKETING</h3>
              <p className="m-0 text-muted small">
                Input personil sales baru ke sistem BPR JATIM
              </p>
            </div>
          </div>

          <Form>
            <Form.Group className="mb-3">
              <label className="small fw-800 text-dark text-uppercase">
                Nomor Induk Kependudukan (NIK)
              </label>
              <div
                className="d-flex align-items-center bg-light border rounded-lg px-3 shadow-sm"
                style={{ height: "55px" }}
              >
                <Form.Control
                  className="border-0 bg-transparent fw-700 h-100"
                  onChange={handleNikChange}
                  value={nik}
                  type="text"
                  placeholder="Masukkan 16 Digit NIK..."
                />
                <span
                  className={`badge ${remainingDigits === 0 ? "badge-success" : "badge-warning"} py-2 px-3`}
                  style={{ borderRadius: "8px" }}
                >
                  {remainingDigits} Digit
                </span>
              </div>
            </Form.Group>

            <Row>
              <Col md="6">
                <Form.Group className="mb-3">
                  <label className="small fw-800 text-dark text-uppercase">
                    Nama Lengkap
                  </label>
                  <Form.Control
                    className="border-0 shadow-sm bg-light fw-600"
                    style={{ height: "50px", borderRadius: "12px" }}
                    placeholder="Nama Lengkap Marketing"
                    onChange={(e) => setNama(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-3">
                  <label className="small fw-800 text-dark text-uppercase">
                    No. Karyawan (Nopeg)
                  </label>
                  <Form.Control
                    className="border-0 shadow-sm bg-light fw-600"
                    style={{ height: "50px", borderRadius: "12px" }}
                    placeholder="Nomor Pegawai"
                    onChange={(e) => setNopeg(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Form.Group className="mb-3">
                  <label className="small fw-800 text-dark text-uppercase">
                    Role Marketing
                  </label>
                  <Select
                    classNamePrefix="react-select"
                    value={pilihRole}
                    onChange={(v) => {
                      setPilihRole(v);
                      setRole(v.value);
                    }}
                    options={[
                      { value: "marketing", label: "Sales Marketing" },
                      { value: "direct marketing", label: "Direct Sales" },
                    ]}
                    placeholder="Pilih Role"
                    styles={{
                      control: (b) => ({
                        ...b,
                        borderRadius: "12px",
                        minHeight: "50px",
                      }),
                    }}
                  />
                </Form.Group>
              </Col>

              {auth.role === "super admin" && (
                <Col md="6">
                  <Form.Group className="mb-3">
                    <label className="small fw-800 text-dark text-uppercase">
                      Pilih Penempatan Client
                    </label>
                    <Select
                      classNamePrefix="react-select"
                      value={pilihClient}
                      onChange={(v) => {
                        setPilihClient(v);
                        setIdClient(v.value);
                      }}
                      options={listClient}
                      placeholder="Pilih Client"
                      styles={{
                        control: (b) => ({
                          ...b,
                          borderRadius: "12px",
                          minHeight: "50px",
                        }),
                      }}
                    />
                  </Form.Group>
                </Col>
              )}
            </Row>

            <div className="mt-4 pt-2">
              <Button
                className="btn-block py-3 border-0 fw-900 shadow-lg"
                style={{
                  background:
                    "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                  borderRadius: "15px",
                  color: "white",
                  fontSize: "16px",
                }}
                onClick={submitMarketing}
              >
                SIMPAN DATA MARKETING
              </Button>
              <Button
                variant="link"
                className="btn-block mt-2 text-muted fw-700 text-decoration-none"
                onClick={() => {
                  handleModalClose();
                  setSalesMarketing(false);
                }}
              >
                Batal & Tutup
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Tab.Content>
        {/* AREA ACTION & SEARCH (STYLE BPR JATIM) */}
        <div className="px-4 py-2 bg-white">
          <Row className="align-items-center justify-content-between">
            {/* Kolom Tombol Tambah Marketing */}
            <Col md="5" xs="12" className="mb-3 mb-md-0">
              {auth.role === "super admin" || auth.role === "admin" ? (
                <Button
                  className="btn-fill btn-wd d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    marginTop: "10px",
                    background:
                      "linear-gradient(135deg, #f90203 0%, #ff4d4d 100%)",
                    fontWeight: "900",
                    border: 0,
                    borderRadius: "12px",
                    padding: "10px 25px",
                    fontSize: "13px",
                    letterSpacing: "0.5px",
                  }}
                  onClick={() => setSalesMarketing(!salesMarketing)}
                >
                  <i className="fas fa-plus-circle mr-2"></i>
                  TAMBAH MARKETING
                </Button>
              ) : null}
            </Col>

            {/* Kolom Search Bar */}
            <Col md="4" xs="12">
              <InputGroup
                className="shadow-none border rounded-lg"
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  backgroundColor: "#f8fafc",
                }}
              >
                <InputGroup.Prepend>
                  <InputGroup.Text className="bg-transparent border-0">
                    <i className="fas fa-search text-muted"></i>
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  className="border-0 bg-transparent fw-600"
                  style={{
                    paddingLeft: "5px",
                    height: "45px",
                    fontSize: "14px",
                  }}
                  type="text"
                  value={searchText}
                  onChange={handleSearch}
                  placeholder="Cari Nama / No. Karyawan..."
                />
              </InputGroup>
            </Col>
          </Row>
        </div>

        <hr className="mx-4 my-4" style={{ opacity: "0.05" }} />

        {/* AREA TABLE / LOADING STATE */}
        <div className="px-4 pb-4">
          {isLoading ? (
            <div
              className="loader-container d-flex flex-column align-items-center justify-content-center"
              style={{
                minHeight: "40vh",
                background: "#f8fafc",
                borderRadius: "20px",
              }}
            >
              <Dna
                visible={true}
                height="100"
                width="100"
                ariaLabel="dna-loading"
              />
              <h6
                className="mt-3 font-weight-bold text-muted"
                style={{ letterSpacing: "2px", fontSize: "12px" }}
              >
                MENYIAPKAN DATA MARKETING...
              </h6>
            </div>
          ) : (
            <div className="table-responsive rounded-xl shadow-sm border bg-white">
              <DataTable
                columns={colSalesMarketing}
                data={listMarketing.filter(
                  (row) =>
                    row.nama.toLowerCase().includes(searchText.toLowerCase()) ||
                    row.nopeg.toLowerCase().includes(searchText.toLowerCase()),
                )}
                customStyles={customStyles}
                pagination
                paginationRowsPerPageOptions={[10, 25, 50, 75, 100]}
                paginationPerPage={itemsPerPage}
                onChangePage={handlePageChange}
                highlightOnHover
                pointerOnHover
              />
            </div>
          )}
        </div>

        <style>{`
    .fw-600 { font-weight: 600; }
    .rounded-xl { border-radius: 15px !important; overflow: hidden; }
    .btn-fill { transition: all 0.3s ease; }
    .btn-fill:hover { 
      transform: translateY(-2px); 
      box-shadow: 0 8px 15px rgba(249, 2, 3, 0.2) !important; 
    }
    
    .input-group:focus-within {
      border-color: #2e3192 !important;
      box-shadow: 0 0 0 0.2rem rgba(46, 49, 146, 0.1) !important;
    }

    .rdt_Pagination {
      font-weight: 700;
      color: #64748b;
    }
  `}</style>
      </Tab.Content>
    </>
  );
}
export default ListMarketing;
